import React from 'react'
import { VscLoading } from "react-icons/vsc";
import { Link } from 'react-router-dom'

import { patient_filter_url, protected_api_call, filter_excel_url } from '../api/api'

class Filter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          
          //   first_name: "", last_name: "", phone: "", email: "", dob: new Date(),
          
          // address: "",city: "", state: "", pincode: "",
          
          hospital: "None", diagonosis: "None", criticalitiy: "None", insurance: "None",
          esrd: "None", references: "None", sfreq: "None", sdate: "",
          comments: "", created_at: "", created_by: "", sstatus: "None",

          first_name: "", last_name: "", dob: "",
        
          results: [],

          loading: false,
          loadingxl: false
      }
    }

    filterFormField = []

    componentDidMount() {
    
      let user_list = JSON.parse(localStorage.getItem("user_data"))["details"]["user_list"]
      this.filterFormField = [
        {
            "name": "Hospital",
            "id_name": "hospital",
            "options": ["Methodist-TW", "Hermann", "Lukes", "NorthWest", "Conroe", "Other-NP", "Other-External"],
            "type": "dropdown"
        },
        {
            "name": "Diagnosis",
            "id_name": "diagonosis",
            "options": ["AKI", "CKD 2", "CKD 3", "CKD 4", "CKD 5", "ESRD", "Transplant", "Hyponatremia", "Hypercalcemia", "Hyper phosphate", "Kidney Stones", "Anemia", "Other"],
            "type": "dropdown"
        },
        {
            "name": "Criticality",
            "id_name": "criticalitiy",
            "options": ["Critical", "Not Critical"],
            "type": "dropdown"
        },
        {
            "name": "Insurance",
            "id_name": "insurance",
            "options": ["Aetna", "Aetna MA", "Medicare", "UHC", "UHC MA", "BCBS", "BCBS MA", "Devoted", "Humana", "Humana MA", "Cigna", "Cigna MA", "Cigna Allegiance", "Tricare", "Veterans Adminstration", "Superior/Ambetter", "Market place plan", "Other"],
            "type": "dropdown"
        },
        {
            "name": "ESRD/CKD",
            "id_name": "esrd",
            "options": ["ESRD", "CKD"],
            "type": "dropdown"
        },
        {
            "name": "Referral",
            "id_name": "references",
            "options": ["PCP", "Specialist", "Family", "NP-LTAC", "Other"],
            "type": "dropdown"
        },
        {
            "name": "Doctor",
            "id_name": "sfreq",
            "options": ["Dr Gandra", "Dr Vuppali", "Dr Patel", "Dr Khaja"],
            "type": "dropdown"
        },
        {
            "name": "Scheduled Date",
            "id_name": "sdate",
            "type": "date"
        },
        {
            "name": "Scheduling Status",
            "id_name": "sstatus",
            "options": ["Scheduled", "Not Scheduled", "Left Voicemail"],
            "type": "dropdown"
        },
        {
            "name": "Comments",
            "id_name": "comments",
            "type": "text"
        },
        {
            "name": "Record Created On",
            "id_name": "created_at",
            "type": "date"
        },
        {
            "name": "Created By",
            "id_name": "created_by",
            "options": user_list,
            "type": "dropdown"
        },
        {
            "name": "First Name",
            "id_name": "first_name",
            "type": "text"
        },
        {
            "name": "Last Name",
            "id_name": "last_name",
            "type": "text"
        },
        {
            "name": "DOB",
            "id_name": "dob",
            "type": "date"
        }

      ]
      this.setState({})
    }

    submit = async () => {
        let data = {
            "hospital": this.state["hospital"], "diagnosis": this.state["diagonosis"],
            "criticality": this.state["criticalitiy"], "insurance": this.state["insurance"],
            "esrd": this.state["esrd"], "references": this.state["references"],
            "sfreq": this.state["sfreq"], "scheduled_date": this.state["sdate"],
            "comments": this.state["comments"], "created_at": this.state["created_at"],
            "created_by": this.state["created_by"], "FirstName": this.state["first_name"], 
            "LastName": this.state["last_name"], "DateOfBirth": this.state["dob"], "ScheduledBoolean": this.state["sstatus"]
        }
        
        this.setState({loading: true})

        let response = await protected_api_call(patient_filter_url, data)
        if(response.status === 200 || response.status === 201) {
            let resp = await response.json()
            this.setState({results: resp["data"], loading: false})
        } else {
            this.setState({loading: false})
            alert("Server Error")
        }   
    }

    excel_report = async () => {
        let data = {
            "hospital": this.state["hospital"], "diagnosis": this.state["diagonosis"],
            "criticality": this.state["criticalitiy"], "insurance": this.state["insurance"],
            "esrd": this.state["esrd"], "references": this.state["references"],
            "sfreq": this.state["sfreq"], "scheduled_date": this.state["sdate"],
            "comments": this.state["comments"], "created_at": this.state["created_at"],
            "created_by": this.state["created_by"], "ScheduledBoolean": this.state["sstatus"],
        }
        
        this.setState({loadingxl: true})

        let response = await protected_api_call(filter_excel_url, data)
        if(response.status === 200 || response.status === 201) {
            let filename = "filtered_report.xlsx";
            response.blob().then(blob => this.download(blob, filename));
            this.setState({loadingxl: false})
        } else {
            this.setState({loadingxl: false})
            alert("Server Error")
        }
    }

    download = (blob, filename) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }


    render(){
      return(
        <>
            <div className=' w-full flex justify-between'>
                <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                    Filters
                </h1>
            </div>
            <div className='flex flex-wrap justify-center '>
                {this.filterFormField.map((data, key) => (
                  data.type === "dropdown" ? (
                    <>
                      <div className='flex flex-col p-2 border border-gray-600 rounded  m-2 w-1/3 '>
                          <h1 className='text-purplegray-900 mb-2'>{data.name}</h1>
                          <select
                              className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                              value={this.state[data.id_name]}
                              onChange = {e => this.setState({[data.id_name]: e.target.value})}>
                              <option value="None">None</option>
                              {data.options.map((option, key) => (
                                  <option key={key} value={option}>{option}</option>
                              ))}
                          </select>
                      </div>
                    </>
                  ) : (
                    <div className='flex flex-col p-2 border border-gray-600 rounded  m-2 w-1/3 '>
                        <h1 className='text-purplegray-900 mb-2'>{data.name}</h1>
                        <input
                            className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                            type={data.type}
                            value={this.state[data.id_name]}
                            onChange = {e => this.setState({[data.id_name]: e.target.value})}
                        />
                    </div>
                  )
                ))}
            </div>

            <div className="w-full flex flex-col items-center mt-5">
                <button
                    type="submit"
                    className="w-1/3 h-12 flex justify-center items-center rounded-lg bg-purple-600 text-purplegray-100 text-lg hover:shadow-md"
                    onClick={this.submit}
                    >
                    {this.state.loading ? <VscLoading className='w-6 h-6 animate-spin' /> : <h1>Filter</h1>}
                </button>
            </div>

            <div className="w-full flex flex-col items-center mt-5">
                <button
                    type="submit"
                    className="w-1/3 h-12 flex justify-center items-center rounded-lg bg-purple-600 text-purplegray-100 text-lg hover:shadow-md"
                    onClick={this.excel_report}
                    >
                    {this.state.loadingxl ? <VscLoading className='w-6 h-6 animate-spin' /> : <h1>Download Excel</h1>}
                </button>
            </div>

            {
                this.state.results.length == 0 ? (
                    <div className='grid mt-10 place-items-center'>
                        <h1 className='text-2xl font-bold border text-purple-800  border-purple-300 px-10 py-2 rounded-lg  bg-purple-200'>NO RESULTS FOUND</h1>
                    </div>
                ) : (
                    <>
                        <div className=' w-full flex justify-between mt-2'>
                            <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                                Results
                            </h1>
                        </div>

                        {this.state.results.map((data, key) => (
                            <div className='flex justify-between items-center bg-purple-200 p-4 rounded-lg my-3 border border-purple-300 rounded-lg'>
                                <h1>Name: {data.FirstName + ' ' + data.LastName}</h1>
                                <h1>Hospital: {data.Hospital}</h1>
                                <h1>Diagnosis: {data.Diagonosis}</h1>
                                <h1>Criticality: {data.Criticality}</h1>
                                <h1>Insurance: {data.Insurance}</h1>
                                {/* <h1> Village: {data.NativeVillage === "" ? "NA" : data.NativeVillage} </h1> */}
                                <div>
                                    {/* <Link to={`/form/auth_${data.ApplicationID}`} state={{ "userinfo": data }} className='bg-green-600 mr-3 p-2 rounded-lg text-white text-center'>
                                        UPDATE
                                    </Link> */}
                                    <Link onClick={(event) => {}} target="_blank" rel="noopener noreferrer" to={`/info/${data.id}`} state={{"userinfo": data}} className='bg-purple-900 p-2 rounded-lg text-white text-center'>
                                        INFO
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </>       
                )
            }
        </>
      )
    }



}


export default Filter